var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "filter-row",
    class: {
      'filter-row_expanded': _vm.expanded,
      'filter-row_active': _vm.active
    }
  }, [_c('div', {
    staticClass: "filter-row__wrapper"
  }, [_c('div', {
    ref: "hiddenWrapper",
    staticClass: "filter-row__hidden-wrapper"
  }, [_vm._l(_vm.list, function (el) {
    var _vm$value;

    return _c('div', {
      key: el.value,
      staticClass: "link link_wu filter-row__link",
      class: {
        'filter-row__link_active': el.value === ((_vm$value = _vm.value) === null || _vm$value === void 0 ? void 0 : _vm$value.value),
        'filter-row__link_reset-needed': _vm.enableReset
      }
    }, [_c('nuxt-link', {
      staticClass: "filter-row__link-text link link_wu",
      attrs: {
        "to": el.property ? el.property : '#',
        "event": "",
        "tag": _vm.tag
      },
      nativeOn: {
        "click": function ($event) {
          return _vm.onChange(el);
        }
      }
    }, [_vm._v("\n          " + _vm._s(el.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "filter-row__reset",
      on: {
        "click": function ($event) {
          return _vm.onChange();
        }
      }
    })], 1);
  }), _vm._v(" "), _c('div', {
    staticClass: "filter-row__show-all"
  }, [_c('span', {
    staticClass: "link-icon link-icon_wu",
    on: {
      "click": _vm.onExpandClick
    }
  }, [_c('div', {
    staticClass: "link-icon__text"
  }, [_vm._v(_vm._s(_vm.expanded ? 'Скрыть' : 'Показать') + " все")]), _vm._v(" "), _c('div', {
    class: [("link-icon__icon-" + (_vm.expanded ? 'top' : 'bottom') + "-arrow")]
  })])])], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }